import { FC } from "react";
import { Typography } from "antd";

const SiteMetricsTab: FC = () => {
    return (
        <div>
            <Typography.Title level={4}>Site Metrics</Typography.Title>
            <Typography.Text>Performance details of sites go here.</Typography.Text>
        </div>
    );
};

export default SiteMetricsTab;
